import { createAction, props } from '@ngrx/store';
import { ThemeRequest } from '../theme.model';

// GET Theme
export const fetchTheme = createAction(`[THEME] - FETCH`);
export const fetchThemeSuccess = createAction(`[THEME] - FETCH - Success`, props<{ themeRequest: ThemeRequest }>());
export const fetchThemeFail = createAction(`[THEME] - FETCH - Fail`, props<{ themeRequest: ThemeRequest }>());
